import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { isNil } from 'lodash';
import { Text, Stack } from 'sarsaparilla';
import { DATE_FORMAT } from '../../constants';

const DisplaytripItinerary = ({ tripItinerary }) => {
  return (
    <Stack space="xs">
      <Text>Trip Itinerary</Text>
      { !isNil(tripItinerary) &&
        tripItinerary.map((element, index) => (
          <div key={`key-${index}`}>
            <Text fontWeight="bold">{moment.utc(element.date).format(DATE_FORMAT)}</Text>
            <Text>{element.name}</Text>
          </div>
        ))
      }
    </Stack>
  );
};

DisplaytripItinerary.propTypes = {
  tripItinerary: PropTypes.arrayOf(PropTypes.object)
};

export default DisplaytripItinerary;
